import { Injectable } from '@angular/core';
import {
  Notification,
  StateFacade as SharedStateFacade
} from '@com-delta-idp/mnx-skymiles-shared';
import { Store, select } from '@ngrx/store';
import { ReplaySubject, Subject } from 'rxjs';
import * as actions from '../+state/actions/landing-page.actions';
import * as selectors from '../+state/selectors/landing-page.selectors';

@Injectable({
  providedIn: 'root'
})
export class StateFacade {
  loaded$;
  medallionBanner$;
  menu$;
  menuData$;
  baseContentError$;
  notification$ = new ReplaySubject<Notification>(1, 8000);
  selectedNotificationTab$ = new Subject<number>();

  constructor(
    private readonly store: Store,
    private readonly sharedState: SharedStateFacade
  ) {
    this.loaded$ = this.store.pipe(select(selectors.getLandingPageLoaded));
    this.medallionBanner$ = this.store.pipe(select(selectors.getMedallionBanner));
    this.menu$ = this.store.pipe(select(selectors.getMenu));
    this.menuData$ = this.store.pipe(select(selectors.getMenuData));
    this.baseContentError$ = this.store.pipe(select(selectors.getBaseContentError));
  }

  init() {
    this.sharedState.init();
    this.store.dispatch(actions.loadAEMMedallionBanner());
    this.store.dispatch(actions.loadAEMMenu());
    this.store.dispatch(actions.loadAEMFeatureFlags());
    this.store.dispatch(actions.loadAEMErrorMessages());
    this.store.dispatch(actions.loadBusinessTravelerFeatureFlagContent());
  }

  triggerMenu() {
    this.menuData$.subscribe((content) => {
      this.store.dispatch(
        actions.loadAEMMenuSuccess({
          aemMenuContent: {
            id: 'aem-menu',
            aemMenu: content
          }
        })
      );
    });
  }
}
